var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.5c-5.966 0-11.55 2.993-14.939 7.998a.328.328 0 0 0 0 .382c3.396 4.997 8.98 7.983 14.939 7.983s11.543-2.986 14.939-7.983a.328.328 0 0 0 0-.382C27.55 10.493 21.966 7.5 16 7.5zm0 13.057a4.883 4.883 0 0 1-4.875-4.875A4.883 4.883 0 0 1 16 10.807a4.883 4.883 0 0 1 4.875 4.875A4.883 4.883 0 0 1 16 20.557z",
    fill: "#4F4F4F",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBlack);
export default __webpack_public_path__ + "static/media/eyeBlack.7c4139aaf34a23adbd083a507b968266.svg";
export { ForwardRef as ReactComponent };